





























import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";

@Component
export default class PreferenzaColloquioCreate extends Vue {
  @Prop() params!: any;
  @Prop() checkInfo!: any;
  private articolazioni: any;
  private idIstituto: number;
  private isIscrizioneAttivita: number;

  private newArticolazione: string;

  constructor() {
    super();
    this.articolazioni = [];
    this.newArticolazione = "";
    this.idIstituto = this.params.idIstituto;
    this.isIscrizioneAttivita = this.params.isIscrizioneAttivita;
  }

  close() {
    this.newArticolazione = "";
    bus.$emit("closeCreateDialog");
  }

  async executeTest() {}

  save() {
    var alreadyExist: boolean = false;
    var nuovaPreferenza = {
      idIscrizioneAttivita: this.params.isIscrizioneAttivita,
      articolazione: this.newArticolazione
    };
    alreadyExist = this.checkInfo.some(
      (preferenza: any) =>
        preferenza["idArticolazione"] === this.newArticolazione
    );
    if (nuovaPreferenza.articolazione !== "") {
      if (alreadyExist) {
        bus.$emit(
          "errorOperation",
          "Preferenza per il settore selezionato già indicata"
        );
      } else {
        this.executeTest().then(() => {
          if (
            (this.$refs.form as Vue & { validate: () => boolean }).validate()
          ) {
            user
              .dispatchCreatePreferenzaColloquio(
                this["$store"],
                nuovaPreferenza
              )
              .then(() => {
                bus.$emit(
                  "successfullOperation",
                  "Preferenza Creata con successo"
                );
                this.close();
                bus.$emit("loadPreferenzeWorkshop");
              })
              .catch(error => {
                if (error.response.status === 403) {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                }
              });
          }
        });
      }
    } else {
      bus.$emit("errorOperation", "Selezionare un Settore");
    }
  }

  loadArticolazioni() {
    var articolazione = {
      idArticolazione: "",
      nomArticolazione: ""
    };
    var articolazioni: any[] = [];
    data
      .dispatchArticolazioni(this["$store"], this.idIstituto)
      .then(response => {
        response.forEach(function(element: any) {
          if (element.idArticolazione != 'LI03') {
            articolazione = {
              idArticolazione: element.idArticolazione,
              nomArticolazione: element.nomeArticolazione
            };
            articolazioni.push(articolazione);
          }
        });
        this.articolazioni = articolazioni;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    this.loadArticolazioni();
  }
}
